<template>
  <div>
    <!-- 课程服务下单对话框 -->
    <el-dialog
      title="课程服务下单"
      :visible.sync="dialogVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="orderForm"
        :model="orderForm"
        :rules="orderRules"
        label-width="100px"
      >
        <el-form-item label="用户电话" prop="phone">
          <el-input
            v-model="orderForm.phone"
            placeholder="请输入用户手机号"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="name">
          <el-input
            v-model="orderForm.name"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="购买数量" prop="course_num">
          <el-input-number
            v-model="orderForm.course_num"
            :min="1"
            :max="999"
            controls-position="right"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="submitOrder" :loading="orderLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 二维码展示对话框 -->
    <el-dialog
      title="支付二维码"
      :visible.sync="qrCodeDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center">
        <img
          :src="qrCodeUrl"
          alt="支付二维码"
          style="width: 300px; height: 300px"
        />
        <p style="margin-top: 20px; color: #666">请使用微信或支付宝扫码支付</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeDialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="reOrder">重新下单</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderDialog",
  props: {
    // 课程数据，包含 id 和 coach_id
    courseData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 对话框显示状态
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      qrCodeDialogVisible: false,
      orderLoading: false,
      orderForm: {
        phone: "",
        name: "",
        course_num: 1,
      },
      orderRules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        name: [{ required: true, message: "请输入用户姓名", trigger: "blur" }],
        course_num: [
          { required: true, message: "请输入购买数量", trigger: "blur" },
        ],
      },
      qrCodeUrl: "",
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
      }
    },
    dialogVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    // 重置表单
    resetForm() {
      this.orderForm = {
        phone: "",
        name: "",
        course_num: 1,
      };
      this.qrCodeUrl = "";
      this.$nextTick(() => {
        this.$refs.orderForm && this.$refs.orderForm.clearValidate();
      });
    },
    // 提交订单
    submitOrder() {
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          if (!this.courseData || !this.courseData.id) {
            this.$message.error("课程信息不完整");
            return;
          }

          this.orderLoading = true;
          const params = {
            phone: this.orderForm.phone,
            name: this.orderForm.name,
            rcharge_type: "coach_service",
            rcharge_abstract: "",
            studycard_id: this.courseData.id,
            pay_type: "qr",
            course_num: this.orderForm.course_num,
            coach_id: this.courseData.coach_id,
            source: "cashier",
          };

          this.$axios
            .post("/user/pay/cashierPay", params)
            .then((res) => {
              this.orderLoading = false;
              this.$message.success("下单成功");
              this.dialogVisible = false;
              // 获取二维码链接并展示
              this.qrCodeUrl = res.data.data.img;

              this.qrCodeDialogVisible = true;
              // 触发成功事件
              this.$emit("success", res.data.data);
            })
            .catch((err) => {
        
              this.orderLoading = false;
              this.$message.error(err.data?.message || "下单失败，请稍后重试");
            });
        }
      });
    },
    // 重新下单
    reOrder() {
      this.qrCodeDialogVisible = false;
      this.resetForm();
    },
    // 取消
    handleCancel() {
      this.dialogVisible = false;
      this.$emit("close");
    },
    // 关闭
    handleClose() {
      this.resetForm();
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
</style>
